module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-473.4116970.woff2";